import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledArrow,
  StyledBodyButton,
  StyledButton,
  StyledCheckBox,
  StyledFilter,
  StyledFilterIcon,
  StyledFilterMain,
  StyledFilterTitle,
  StyledHeading,
  StyledInput,
  StyledLabel,
  StyledLeftCard,
  StyledModal,
  StyledRefresh,
  StyledSelect,
  StyledShowButton,
  StyledTitle,
} from './FilterJobs.styled'
import HeadingSizeEnum from '../../enums/headingSize'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import NewJobsEnum from '../../enums/jobSearch/NewJobsEnum'
import InternshipsEnum from '../../enums/jobSearch/InternshipsEnum'
import RemotePositionsEnum from '../../enums/jobSearch/RemotePositionsEnum'
import FiltersEnum from '../../enums/jobSearch/FiltersEnum'
import ShowResultsEnum from '../../enums/jobSearch/ShowResultsEnum'
import ResetFiltersEnum from '../../enums/jobSearch/ResetFiltersEnum'
import FiltersLocationsEnum from '../../enums/jobSearch/FiltersLocationsEnum'

const filtersNamesEnum = {
  cat: 'cat',
  c: 'c',
  s: 's',
  l: 'l',
}

const FilterJobs = ({
  boxes,
  isTablet,
  filters,
  setFilters,
  resetFilters,
  onClose,
  showFilters,
  toggleFilters,
  locale,
}) => {
  const handleCheckboxChange = (e, identifier) => {
    const { checked } = e.target
    setFilters({
      ...filters,
      [identifier]: checked,
    })
  }

  const handleSelectChange = (e, identifier) => {
    if (e.select?.length >= 0) {
      const values = e.select.map((option) => option.value)
      setFilters({
        ...filters,
        [identifier]: [...values],
      })
      return
    }

    const value = e?.select?.value

    setFilters({
      ...filters,
      [identifier]: value ? [value] : [],
    })
  }

  const filtersMatcher = {
    'Only Show New Jobs': NewJobsEnum[locale],
    'Only Show Internships': InternshipsEnum[locale],
    'Only Show Remote Positions': RemotePositionsEnum[locale],
    'Country: Select': FiltersLocationsEnum.country[locale],
    'State / Region: Select': FiltersLocationsEnum.state[locale],
    'Location: Select': FiltersLocationsEnum.location[locale],
    'Job Category: Select': FiltersLocationsEnum.category[locale],
  }

  const filtersList = boxes.map((box) => {
    if (box.type === 'checkbox') {
      return (
        <StyledCheckBox key={box.value}>
          <StyledInput
            type="checkbox"
            id={box.title}
            name={box.title}
            checked={filters[box.value]}
            onChange={(e) => handleCheckboxChange(e, box.value)}
          />
          <StyledLabel htmlFor={box.title}>
            {filtersMatcher[box.title]}
          </StyledLabel>
        </StyledCheckBox>
      )
    } else if (box.type === 'select') {
      const values = filters[box.value].map((value) => ({
        value,
        label: value,
      }))

      return (
        <StyledSelect
          key={box.value}
          onChange={(e) => handleSelectChange(e, box.value)}
          isMulti={box.value === filtersNamesEnum.cat && true}
          isClearable
          options={box.options}
          value={
            box.value === filtersNamesEnum.cat
              ? values
              : values[0]?.value
              ? values[0]
              : []
          }
          placeholder={filtersMatcher[box.description]}
        />
      )
    }
    return null
  })
  if (isTablet && !showFilters) {
    return (
      <StyledFilter>
        <StyledFilterTitle onClick={toggleFilters}>
          {FiltersEnum[locale]}
          <StyledFilterIcon />
        </StyledFilterTitle>
      </StyledFilter>
    )
  } else if (isTablet) {
    return (
      <StyledModal $showFilters={showFilters}>
        <StyledFilterMain isTablet>
          <StyledLeftCard>
            <StyledHeading>
              <StyledArrow onClick={onClose} />
              <StyledTitle
                label={FiltersEnum[locale]}
                size={HeadingSizeEnum.h3}
              />
              <StyledButton onClick={resetFilters}>
                {ResetFiltersEnum[locale]}
                <StyledRefresh />
              </StyledButton>
            </StyledHeading>
            {filtersList}
            <StyledBodyButton>
              <StyledShowButton
                onClick={onClose}
                variant={ButtonVariantEnum.primary}
              >
                {ShowResultsEnum[locale]}
              </StyledShowButton>
            </StyledBodyButton>
          </StyledLeftCard>
        </StyledFilterMain>
      </StyledModal>
    )
  }
  return (
    <StyledFilterMain>
      <StyledLeftCard>
        <StyledHeading>
          <StyledTitle label={FiltersEnum[locale]} size={HeadingSizeEnum.h3} />
          <StyledButton onClick={resetFilters}>
            {ResetFiltersEnum[locale]}
            <StyledRefresh />
          </StyledButton>
        </StyledHeading>
        {filtersList}
      </StyledLeftCard>
    </StyledFilterMain>
  )
}

FilterJobs.propTypes = {
  boxes: PropTypes.array.isRequired,
}

export default FilterJobs
